document.addEventListener("DOMContentLoaded", () => {
    const tocElement = document.querySelector(".toc");
    if (!tocElement) return;

    const tocList = document.querySelector(".toc__list");
    const contentArea = document.querySelector(".page-content");
    const headingsArray = Array.from(contentArea.querySelectorAll("h2")).filter(
        (h2) => !h2.classList.contains("toc-exclude")
    );

    if (headingsArray.length > 0) {
        headingsArray.forEach((h2) => {
            const existingId = h2.getAttribute("id");
            const heading = h2.innerText;
            const id = existingId || makeID(heading);
            h2.setAttribute("id", id);

            const anchor = `
                <li class="toc__anchor">
                    <a href="#${id}">${heading}</a>
                </li>
            `;

            tocList.innerHTML += anchor;
        });
        tocElement.style.display = "block";
    } else {
        tocElement.remove();
    }
});

function makeID(text) {
    const prefix = "section-";
    let id = text
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-") // Replace one or more non-alphanumeric characters with a single hyphen
        .replace(/^-+|-+$/g, ""); // Remove leading or trailing hyphens

    return prefix + id;
}
